import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[NumberOnly]'
})
export class NumberOnlyDirective {
  // Allow decimal numbers and negative values
  // private regex: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
  // private regex: RegExp = new RegExp(/^[\d]+[\.][\d]{2}$/g);
  private regex: RegExp = new RegExp(/^([0-9]*)+\.?[0-9]{0,2}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Decimal', 'Del', 'Delete', 'Left', 'Right', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = event.key;

    if (current) {
      
      let firstPart = current.substr(0, this.el.nativeElement.selectionStart);
      let secondPart = current.substr(this.el.nativeElement.selectionStart + (this.el.nativeElement.selectionEnd - this.el.nativeElement.selectionStart), current.length - 1);

      next = firstPart + next + secondPart;

    } 

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/NumericalTextBox/NumberTextBox.ts